import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class webSiteschemaService {
  private renderer2: Renderer2;
  constructor(@Inject(DOCUMENT) private document: Document, private rendererFactory: RendererFactory2) {
    this.renderer2 = this.rendererFactory.createRenderer(null, null);
  }

  setWebSiteSchema(): void {
    const scriptTag = this.renderer2.createElement('script');
    scriptTag.type = 'application/ld+json';
    scriptTag.text = this.getWebSiteSchema();
    this.renderer2.appendChild(this.document.head, scriptTag);
  }

  getWebSiteSchema(): string {
    const schemaObj = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      url: 'https://www.tendershark.com/',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://www.tendershark.com/all-tenders/active?search=&query={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    };
    return JSON.stringify(schemaObj);
  }
}